import { FC } from "react";

import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Skeleton from "@mui/material/Skeleton";

const CartContentSkeleton: FC = () => (
  <Box sx={{ p: 3 }}>
    <Card>
      <CardContent sx={{ display: "flex", flexDirection: "column", gap: 1.5 }}>
        <Skeleton variant="text" width="50%" height={32} />
        <Skeleton variant="rounded" width={120} height={24} />
        <Skeleton variant="rounded" width={180} height={36} />
        <Skeleton variant="text" width={100} sx={{ alignSelf: "flex-end" }} />
      </CardContent>
    </Card>
  </Box>
);

export default CartContentSkeleton;
